/* ============================================================
   ลิงก์เลขที่เอกสาร / รหัสข้อมูลหลัก ในตารางรายการ

   กดแล้วเปิดหน้าแสดงข้อมูลของเอกสารนั้น (ตัวเดียวกับปุ่มแก้ไข/ดู)
   ใช้ Typography.Link ธรรมดา ไม่ได้เปลี่ยน URL เอง จึงไม่กระทบ
   ประวัติเบราว์เซอร์ — กด "ย้อนกลับ" แล้วกลับมาหน้ารายการเดิม
   พร้อมเงื่อนไขค้นหา/หน้าที่เปิดค้างไว้ (useAccessPageState คืนค่าให้)

   ค่าว่างหรือไม่มี handler จะแสดงเป็นข้อความธรรมดา ไม่ทำเป็นลิงก์
============================================================ */
import React from "react";
import { Typography, Tooltip } from "antd";

export default function DocLink({
  value,
  record,
  onClick,
  title = "เปิดดูเอกสาร",
}) {
  const text = value === null || value === undefined ? "" : String(value);

  if (!text.trim() || typeof onClick !== "function") {
    return <span>{text || "-"}</span>;
  }

  return (
    <Tooltip title={title}>
      <Typography.Link
        className="hover:!underline"
        onClick={(e) => {
          /* กันไม่ให้ไปโดน onRow/ปุ่มอื่นในแถวเดียวกัน */
          e.stopPropagation();
          onClick(record);
        }}
      >
        {text}
      </Typography.Link>
    </Tooltip>
  );
}

/* ตัวช่วยสร้าง render ให้คอลัมน์ ใช้ในไฟล์ model.js ได้สั้น ๆ
     render: docLinkRender(handleEdit)                       */
export const docLinkRender =
  (onClick, title) =>
  (value, record) =>
    <DocLink value={value} record={record} onClick={onClick} title={title} />;
